var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xD0\xA1lose Big",
    d: "M15.0007 16.773L8.36635 23.4073C8.05807 23.7156 7.53926 23.7185 7.22547 23.4152C6.92213 23.1014 6.925 22.5826 7.23328 22.2743L13.8676 15.6399L7.23328 9.0056C6.93178 8.7041 6.91385 8.16914 7.23328 7.87253C7.54154 7.56427 8.05673 7.5629 8.36635 7.87253L15.0007 14.5069L21.635 7.87253C21.9452 7.56233 22.4599 7.56431 22.7681 7.87253C23.0763 8.18074 23.0783 8.69541 22.7681 9.0056L16.1338 15.6399L22.7681 22.2743C23.0777 22.5839 23.0764 23.0991 22.7681 23.4073C22.4715 23.7268 21.9365 23.7088 21.635 23.4073L15.0007 16.773Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlue);
export default __webpack_public_path__ + "static/media/CloseBlue.b87dceed01a1351d9c6108fe91692536.svg";
export { ForwardRef as ReactComponent };